import { ChangeDetectionStrategy, Component, OnDestroy, computed, inject, input } from '@angular/core';
import { NavigationEnd, NavigationStart, NavigationCancel, NavigationError, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from '../../core/app.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { VlNavProgressComponent } from '../loaders/vl-loaders';
import { LoadingService, VL_MIN_LOADER_MS } from '../loaders/loading.service';
import { ChatLauncherComponent } from '../../screens/messages/chat-launcher.component';
import { IssueReporterComponent } from '../../screens/issues/reporter/issue-reporter.component';
import { VoyagoMascotComponent } from './voyago-mascot/voyago-mascot.component';
import { UserPreferencesService } from '../../core/user-preferences.service';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [SidebarComponent, TopbarComponent, VlNavProgressComponent, ChatLauncherComponent, IssueReporterComponent, VoyagoMascotComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shell.html',
})
export class AppShellComponent implements OnDestroy {
  readonly app = inject(AppService);
  readonly crumbs = input<readonly string[]>([]);
  // Instantiate so it loads per-user prefs on login + saves changes to backend.
  private readonly prefs = inject(UserPreferencesService);

  private readonly loading = inject(LoadingService);
  private readonly sub = new Subscription();
  private releaseNav: (() => void) | null = null;

  /** Drives the {@code app-vl-nav-progress} bar. True whenever the
   *  router is mid-transition or any other task is registered against
   *  {@link LoadingService}. */
  readonly progressActive = computed(() => this.loading.active());

  constructor(router: Router) {
    // Route changes briefly raise the bar — held for the same 1-second
    // floor as every other loader so the indicator never flashes.
    this.sub.add(
      router.events.subscribe((ev) => {
        if (ev instanceof NavigationStart) {
          this.releaseNav?.();
          this.releaseNav = this.loading.acquire(VL_MIN_LOADER_MS);
        } else if (
          ev instanceof NavigationEnd ||
          ev instanceof NavigationCancel ||
          ev instanceof NavigationError
        ) {
          this.releaseNav?.();
          this.releaseNav = null;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
